module.exports = __webpack_public_path__ + "img/SC.7b8abfa4.png";